import React from 'react';
import { Icon, HStack, Flex, Box, Button } from '@wegroup/design-system';
import AssistantQuestion from '../../../../sales-conversation/src/components/flow/AssistantQuestion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { chakraCustomScrollBar } from '../../../../common/src/utils/styledComponentsUtils';
import { use100vh } from 'react-div-100vh';
import { useLocation } from 'react-router';

interface Props {
  question: string;
  description?: string;
  onContinueUrl?: string;
  onBackUrl?: string;
  disabled?: boolean;
  onContinueClick?: () => void;
}

const SelectionViewWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  description,
  onBackUrl = '#',
  onContinueUrl = '#',
  onContinueClick,
  children,
  disabled,
}) => {
  const { t } = useTranslation();
  const height = use100vh() || '100vh';

  const { search } = useLocation();

  const backUrl = onBackUrl + search;
  const continueUrl = onContinueUrl + search;

  return (
    <Flex
      direction="column"
      align="stretch"
      justifyContent="space-between"
      h={{ base: height, mobileL: '90vh' }}
      maxH={{ base: height, mobileL: '800px' }}
      overflow="auto"
      sx={chakraCustomScrollBar}
      position="relative"
      maxW="100vw"
      borderRadius="10px"
    >
      {/* QUESTION */}
      <Box
        flexShrink={0}
        pt="4"
        pb="2"
        px={{ base: '4', mobileM: '6', mobileL: '12' }}
        sx={{ '> div': { mb: 0 } }}
        bgColor="white"
      >
        <AssistantQuestion
          noPadding
          question={question}
          description={description}
        />
      </Box>

      {/* INPUT */}
      <Box px={{ base: '4', laptop: '12' }} py="3" flexGrow={1}>
        {children}
      </Box>
      {/* ACTIONS */}
      <HStack
        py="4"
        px="6"
        justifyContent="flex-end"
        flexShrink={0}
        spacing="6"
        maxW="100vw"
        position="sticky"
        bottom="0"
        bgColor="white"
      >
        <Button
          as={Link}
          variant="grayedGhost"
          borderRadius="full"
          to={backUrl}
          // not using _hover because it will overwrite the original hover state
          sx={{ ':hover': { path: { stroke: 'primary.500' } } }}
          leftIcon={
            <Box transform="rotate(180deg)">
              <Icon name="IconArrow" color="currentcolor" />
            </Box>
          }
          data-test-id="RISK-ANALYSIS_SELECTION-VIEW_BUTTON-BACK"
        >
          {t('Go back')}
        </Button>
        {onContinueClick ? (
          <Button
            onClick={onContinueClick}
            borderRadius="full"
            isDisabled={disabled}
            data-test-id="RISK-ANALYSIS_SELECTION-VIEW_BUTTON-CONTINUE"
          >
            {t('Continue')}
          </Button>
        ) : (
          <Button
            as={Link}
            to={disabled ? '#' : continueUrl}
            borderRadius="full"
            isDisabled={disabled}
            data-test-id="RISK-ANALYSIS_SELECTION-VIEW_BUTTON-CONTINUE"
          >
            {t('Continue')}
          </Button>
        )}
      </HStack>
    </Flex>
  );
};

export default SelectionViewWrapper;
